import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sobre-copend-med',
  templateUrl: './sobre-copend-med.component.html',
  styleUrls: ['./sobre-copend-med.component.css']
})
export class SobreCOpendMedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
